import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apartmentActions } from "../features/apartments/reducer";
import { selectHasInitialized } from "../features/apartments/selectors";

export const useInitApp = () => {
  const dispatch = useDispatch();
  const hasInitialized = useSelector(selectHasInitialized);

  useEffect(() => {
    if (hasInitialized) return;
    dispatch(apartmentActions.initApp());
  }, [dispatch, hasInitialized]);
};
